//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CardPropertyIcon from './CardPropertyIcon.vue'
import { cardPropertyMixin } from './CardPropertyMixin.js'
import { cardPropertyConfigurableMixin } from './CardPropertyConfigurableMixin.js'

export default {
  name: 'CardPropertyBoolean',
  components: {
    CardPropertyIcon
  },
  mixins: [cardPropertyMixin, cardPropertyConfigurableMixin],
  props: {
    tabProp: {
      type: Object,
      default: null
    },
    object: {
      type: Object,
      default: null
    },
    objectInitial: {
      type: Object,
      default: null
    }
  },
  computed: {
    afterBtn: function () {
      return null
    }
  },
  methods: {
    onInput: function (value) {
      if (this.tabProp.onPropertyInput instanceof Function) {
        this.tabProp.onPropertyInput(value, this.object)
      }
    }
  }
}
